<template>
  <section>
    <div class="columns is-multiline filters">
      <div class="column is-12-mobile is-6-tablet">
        <b-field :label="$t('purchases.code')">
          <b-input
            :value="searchBarcode"
            icon="barcode"
            @input="$emit('update-search-barcode', $event)"
          ></b-input>
        </b-field>
      </div>

      <div class="column is-12-mobile is-6-tablet">
        <b-field :label="$t('purchases.name')">
          <b-input
            :value="searchName"
            icon="list"
            @input="$emit('update-search-name', $event)"
          ></b-input>
        </b-field>
      </div>
    </div>

    <b-table
      class="sticky-table-header"
      :data="purchases"
      narrowed
      hoverable
      id="purchases-table"
      backend-sorting
      :default-sort-direction="sortOrder"
      :default-sort="[sortField, sortOrder]"
      @sort="handleSort"
    >
      <b-table-column
        field="b"
        :label="$t('purchases.code')"
        sortable
        v-slot="props"
      >
        <span class="adjust-top-text">
          <b-tooltip
            :label="$t('purchases.purchaseExclusionTip')"
            position="is-right"
          >
            <b-icon
              icon="minus-circle"
              v-if="props.row.lc === 0"
              type="is-danger"
              size="is-small"
            ></b-icon>
          </b-tooltip>
          {{ props.row.b }}
        </span>
      </b-table-column>

      <b-table-column
        field="n"
        :label="$t('purchases.name')"
        sortable
        v-slot="props"
      >
        <span class="adjust-top-text">{{ props.row.n }}</span>
      </b-table-column>

      <b-table-column
        field="lc"
        :label="$t('purchases.cost')"
        sortable
        v-slot="props"
      >
        <money
          v-model="props.row.lc"
          v-bind="money"
          class="input is-expanded"
          @blur.native="updateCost(props.row)"
          @focus.native="registerOriginalCost(props.row.lc)"
          style="width: 100px"
          :disabled="!permissions.addUpdatePurchase"
        ></money>
      </b-table-column>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="sad-cry" size="is-large"></b-icon>
            </p>
            <p>{{ $t("common.tableEmptyMessage") }}</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { Money } from "v-money";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";

export default {
  props: {
    purchases: {
      type: Array,
      default: () => []
    },
    searchBarcode: {
      type: String,
      default: ""
    },
    searchName: {
      type: String,
      default: ""
    },
    sortField: {
      type: String,
      default: "n"
    },
    sortOrder: {
      type: String,
      default: "asc"
    }
  },

  mixins: [common, mask],

  components: {
    Money
  },

  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2
      },
      initialCost: 0
    };
  },

  methods: {
    handleSort(field, order) {
      this.$emit("update-sort", { field, order });
    },

    registerOriginalCost(cost) {
      this.initialCost = cost;
    },

    updateCost(product) {
      if (product.lc === this.initialCost) return;

      const lc = Number(String(product.lc.toFixed(2)).replace(/[^0-9]+/g, ""));

      // Custo zerado remove o custo do produto, como o preço zerado remove o
      // produto do catálogo na tela de produtos.
      if (lc === 0) {
        if (!this.permissions.removePurchase) {
          this.alertError({ message: "ACTION_NOT_AUTHORIZED" });
          product.lc = this.initialCost;
          return false;
        }

        this.$buefy.dialog.confirm({
          message: this.$t("purchases.confirmPurchaseRemotion", {
            name: product.n
          }),
          confirmText: this.$t("common.yes"),
          cancelText: this.$t("common.cancel"),
          onConfirm: () => {
            this.$emit("remove-purchase", { b: product.b, n: product.n });
          },
          onCancel: () => {
            product.lc = this.initialCost;
          }
        });

        return;
      }

      this.$emit("update-cost", {
        product: { ...product, lc }
      });
    }
  },

  computed: {
    ...mapGetters(["permissions", "payments", "address"])
  },

  mounted() {
    this.money.prefix = `${this.payments.currencySymbol} `;
  }
};
</script>

<style scoped>
#purchases-table {
  cursor: pointer !important;
}
.adjust-top-text {
  position: relative;
  top: 8px;
}
.adjust-top-button {
  position: relative;
  top: 4px;
}
</style>
